import React from 'react';
import './FrameworkGuide.css';

interface FrameworkGuideProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}

const FrameworkGuide: React.FC<FrameworkGuideProps> = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div className="framework-guide-overlay" onClick={onClose}>
      <div className="framework-guide-modal" onClick={(e) => e.stopPropagation()}>
        <div className="framework-guide-header">
          <h2 className="framework-guide-title">{title} Guide</h2>
          <button className="framework-guide-close" onClick={onClose}>×</button>
        </div>
        <div className="framework-guide-content">
          {content}
        </div>
      </div>
    </div>
  );
};

export default FrameworkGuide;

